<template>
  <div>
    <v-alert v-if="errors.length" type="error" class="ma-4" dismissible @input="clearErrors">
      <div v-for="(error, i) in errors" :key="i">{{ error }}</div>
    </v-alert>

    <v-alert v-if="successes.length" type="success" class="ma-4" dismissible @input="clearSuccesses">
      <div v-for="(success, i) in successes" :key="i">{{ success }}</div>
    </v-alert>

    <!-- User Card-->
    <ClientCard :content="content" :save-customer="saveCustomer" :disabled="disabled" :content-altered-values="contentAlteredValues" />

    <!-- Emergency Contacts Card-->
    <EmergencyContactsCard :content="content" :save-customer="saveCustomer" :disabled="disabled" :content-altered-values="contentAlteredValues" />

    <!-- Context Card -->
    <ContextCard :content="content" :add-context-to-user="addContextToUser" :disabled="disabled" :remove-iresa-id="removeIresaId" :content-altered-values="contentAlteredValues" />

    <!-- Hello Groups Card -->
    <HelloGroupsCard v-if="!disabled" :content="content" />

    <!-- Contacts Card -->
    <ContactsCard v-if="content.contacts || content.contacts_from" :content="content" :disabled="disabled" :save-customer="saveCustomer" :content-altered-values="contentAlteredValues" />

    <!-- Identifiants Card-->
    <IdentifiantsCard :content="content" :save-customer="saveCustomer" :disabled="disabled" :content-altered-values="contentAlteredValues" />

    <!-- Contact Preferences Card -->
    <ContactPreferencesCard v-if="content.newsletters" :content="content" :save-customer="saveCustomer" />

    <!-- Confiance Card -->
    <ConfianceCard :content="content" :save-customer="saveCustomer" :disabled="disabled" :content-altered-values="contentAlteredValues" />

    <SearchPartner ref="partnerSearch" :add-context-to-user="addContextToUser" :add-exist-iresa-id-to-user="addExistIresaIdToUser" />
  </div>
</template>

<script>
import SearchPartner from '@/components/search/SearchPartner';

import ClientCard from '@/components/profile/ClientCard.vue';
import ContextCard from '@/components/profile/ContextCard.vue';
import HelloGroupsCard from '@/components/profile/HelloGroupsCard.vue';
import ContactsCard from '@/components/profile/ContactsCard.vue';
import IdentifiantsCard from '@/components/profile/IdentifiantsCard.vue';
import ContactPreferencesCard from '@/components/profile/ContactPreferencesCard.vue';
import ConfianceCard from '@/components/profile/ConfianceCard.vue';

import EmergencyContactsCard from '@/components/profile/EmergencyContactsCard.vue';

import { EventBus } from '../../../mixins';

export default {
  name: 'ProfileSpeedboatContact',
  components: {
    SearchPartner,
    ClientCard,
    ContextCard,
    HelloGroupsCard,
    ContactsCard,
    IdentifiantsCard,
    ContactPreferencesCard,
    EmergencyContactsCard,
    ConfianceCard
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    successes: {
      type: Array,
      default: () => []
    },
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    addContextToUser: {
      type: Function,
      default: () => {}
    },
    addExistIresaIdToUser: {
      type: Function,
      default: () => {}
    },
    removeIresaId: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: null
    }
  },
  methods: {
    clearErrors () {
      EventBus.$emit('change-errors', []);
    },
    clearSuccesses () {
      EventBus.$emit('change-successes', []);
    }
  }
};
</script>

<style lang="scss">
.card-title-height {
  height: 56px;
}

</style>
